import http from "infra/http";
import { useQuery } from "react-query";
import { ArrecadacaoFiltro, ArrecadacaoItemResponse } from "./typings";

function useArrecadacoes(filters: ArrecadacaoFiltro) {
  return useQuery(
    [
      `/v1/tenants/arrecadacao-${filters.page}-${filters.limit}-${filters.search}-${filters.ano}-${filters.mes}`,
    ],
    async () => {
      const { data } = await http.get<ArrecadacaoItemResponse[]>(
        "/v1/arrecadacao",
        {
          params: filters,
        }
      );

      return data;
    },
    {
      enabled: !!filters.ano && !!filters.mes,
    }
  );
}

export default useArrecadacoes;
